import { DatePicker, Select } from 'antd'
import axios from 'axios'
import React, { useCallback, useEffect, useState } from 'react'
import apiUrls from '../../../Api/MainApi'
import dayjs from 'dayjs';
import moment from 'moment';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

function EditBikeDetails({ formData, setFormData, }) {
    const [makeDropdown, setMakeDropDown] = useState([])
    const [modelDropdown, setModelDropDown] = useState([])
    const [variantDropdown, setVariantDropDown] = useState([])
    const [rtoDropdown, setRtoDropDown] = useState([])

    const [loading, setLoading] = useState(false);

    const fetchRtoData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axios.get(apiUrls.GetRtoDropDown);
            setRtoDropDown(response.data.data);
        } finally {
            setLoading(false);
        }
    }, []);
    // Memoized function to fetch make data
    const fetchMakeData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axios.post(apiUrls.GetMakeDropDown, { searchtext: '', VehicleType: "Bike" });
            setMakeDropDown(response.data.data);
        } finally {
            setLoading(false);
        }
    }, []);

    // Memoized function to fetch model data based on make
    const fetchModelData = useCallback(async (make) => {
        setLoading(true);
        try {
            const response = await axios.post(apiUrls.GetModelDropDown, { MakeID: make, searchtext: '' });
            setModelDropDown(response.data.data);
        } finally {
            setLoading(false);
        }
    }, []);

    // Memoized function to fetch variant data based on make and model
    const fetchVariantData = useCallback(async (make, model) => {
        setLoading(true);
        try {
            const response = await axios.post(apiUrls.GetVariantDropDown, { MakeID: make, MakeModelID: model, searchtext: '' });
            setVariantDropDown(response.data.data);
        } finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchMakeData();
        fetchRtoData();
    }, [fetchMakeData, fetchRtoData]);

    // Fetch model data when make changes
    useEffect(() => {
        if (formData.make) {
            fetchModelData(formData.make);
        }
    }, [formData.make, fetchModelData]);

    // Fetch variant data when make or model changes
    useEffect(() => {
        if (formData.make && formData.model) {
            fetchVariantData(formData.make, formData.model);
        }
    }, [formData.make, formData.model, fetchVariantData]);
    const handleMakeChange = (selectedOption, option) => { // to store and manipulate the data from the make dropdown
        setFormData(prev => ({
            ...prev,
            make: selectedOption,
            model: null,
            variant: null,
            makeLabel: option.label
        }))
    }
    const handleModelChange = (selectedOption, option) => { // to store and manipulate the data from the model dropdown
        setFormData(prev => ({
            ...prev,
            model: selectedOption,
            variant: null,
            modelLabel: option.label
        }))
    }
    const handleVariantChange = (selectedOption) => { // to store and manipulate the data from the variant dropdown
        setFormData(prev => ({
            ...prev,
            variant: selectedOption,
        }))
    }
    const handleRtoChange = (selectedOption) => { // to store and manipulate the data from the make dropdown
        setFormData(prev => ({
            ...prev,
            rto: selectedOption
        }))
    }
    const handleYearChange = (date, dateString) => {
        setFormData(prevData => ({
            ...prevData,
            year: dateString ? moment(dateString, 'DD-MM-YYYY').format('DD-MM-YYYY') : ''
        }));
    }
    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    const disabledDate = (current) => {    // to diable the date that is more than registration Date 
        if (formData.registrationNUmber) {
            alert(1)
            return current && current > dayjs(formData.registrationDate, 'DD-MM-YYYY');
        }
        return false;
    }
    const defaultPickerValue = () => {  // to show the dates according to the registration info is present or not 
        if (formData.licensePlateNumber && formData.registrationDate) {
            return dayjs(formData.registrationDate, 'DD-MM-YYYY');
        }
        return undefined;
    }
    return (
        <>
            <div className='wrapper-div-rto'>
                <div className='container'>
                    <h6 className='select-label-title'>Rto</h6>
                    <Select
                        name="Rto"
                        style={{
                            width: '100%',
                        }}
                        showSearch
                        filterOption={filterOption}
                        value={formData.rto}
                        onChange={handleRtoChange}
                        options={(rtoDropdown || [
                            {
                                id: 0,
                                name: "No Rto Found",
                            }
                        ]).map((make) => ({ value: make.id, label: make.name }))}
                        placeholder="Select Rto location"
                    />
                </div>
            </div>

            {/* /// for manufaturer /////// */}
            <div className='wrapper-div-rto'>
                <div className='container'>
                    <h6 className='select-label-title'>Make</h6>
                    <Select
                        name="Make"
                        style={{
                            width: '100%',
                        }}
                        showSearch
                        filterOption={filterOption}
                        value={formData.make}
                        onChange={handleMakeChange}
                        // className="width-specifiying"
                        loading={loading}
                        disabled={formData.make}
                        options={(makeDropdown.length > 0 ? makeDropdown : [{ id: 0, name: "No Make Found" }]).map(make => ({ key: `make-${make.id}`, value: make.id, label: make.name }))}
                        placeholder="Select Make"
                    />
                </div>
            </div>
            <div className='wrapper-div-rto'>
                <div className='container'>
                    <h6 className='select-label-title'>Model</h6>
                    <Select
                        name="Model"
                        style={{
                            width: '100%',
                        }}
                        showSearch
                        filterOption={filterOption}
                        value={formData.model}
                        onChange={handleModelChange}
                        // className="width-specifiying"
                        options={(modelDropdown.length > 0 ? modelDropdown : [{ id: 0, name: "No Model Found" }]).map(model => ({ key: `model-${model.id}`, value: model.id, label: model.name }))}
                        placeholder="Select Model"
                        disabled={!formData.make || formData.model}
                        loading={loading}
                    />
                </div>
            </div>
            <div className='wrapper-div-rto'>
                <div className='container'>
                    <h6 className='select-label-title'>Variant</h6>
                    <Select
                        name="Variant"
                        style={{
                            width: '100%',
                        }}
                        showSearch
                        filterOption={filterOption}
                        value={formData.variant}
                        onChange={handleVariantChange}
                        // className="width-specifiying"
                        loading={loading}
                        options={(variantDropdown.length > 0 ? variantDropdown : [{ id: 0, name: "No Variant Found" }]).map(variant => ({ key: `variant-${variant.id}`, value: variant.id, label: variant.name }))}
                        placeholder="Select Variant"
                        disabled={!formData.model}
                    />
                </div>
            </div>
            {/* ///// for variant //// */}
            <div className='wrapper-div-rto'>
                <div className='container'>
                    <h6 className='select-label-title'>Manufacturing Year</h6>
                    <DatePicker
                        style={{
                            width: '100%',
                        }}
                        defaultValue={formData.year ? dayjs(formData.year, 'DD-MM-YYYY') : null}
                        className='width-date'
                        onChange={handleYearChange}
                        format='DD-MM-YYYY'
                        disabledDate={disabledDate}
                        defaultPickerValue={defaultPickerValue()}
                    />
                </div>
            </div>
        </>
    )
}
export default EditBikeDetails